

export class SelectCountryLanguageQuery {
  readonly eql = `SELECT de_id, de_ke, de_li, de_char1, de_char2 FROM de WHERE de.de_tp = 'COUNTRY' and (de.de_co != 'CONTINENT' or de.de_co IS NULL)`;
  readonly cacheKey = 'SelectCountryLanguageQuery';
  readonly signature = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlcWwiOiJTRUxFQ1QgZGVfaWQsIGRlX2tlLCBkZV9saSwgZGVfY2hhcjEsIGRlX2NoYXIyIEZST00gZGUgV0hFUkUgZGUuZGVfdHAgPSAnQ09VTlRSWScgYW5kIChkZS5kZV9jbyAhPSAnQ09OVElORU5UJyBvciBkZS5kZV9jbyBJUyBOVUxMKSJ9.bIC9zkgI8t4QKDf0RZux6cDPzVZdvVB4cV0WP9jD_qw';

  variables: {
    
  }
  constructor() {
    this.variables = { };
  }


}
